<div style="padding:10px; text-align: center; margin-top: 10%;">
   <div style="font-weight: bold; font-size: x-large;">Reset Password</div>


   <div style="color: red; font-size: smaller; margin-top: 2em;" *ngIf="error">
      {{error}}
   </div>
   <div *ngIf="token" class="frame">

      <div>
         <mat-form-field>

            <input matInput type="password" [(ngModel)]="password" placeholder="New Password">
         </mat-form-field>

      </div>
      <div>

         <mat-form-field>

            <input matInput type="password" [(ngModel)]="password2" placeholder="Confirm Password">
         </mat-form-field>
      </div>

      <div>
         <button mat-flat-button color="primary" (click)="proceed()">Reset Password</button>
      </div>
   </div>
   
</div>
